/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Permission_Name_Usersettings_ModifyInputs */

const en_enum_permission_name_usersettings_modify = /** @type {(inputs: Enum_Permission_Name_Usersettings_ModifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name Usersettings Modify`)
};

const de_enum_permission_name_usersettings_modify = /** @type {(inputs: Enum_Permission_Name_Usersettings_ModifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name Usersettings Modify`)
};

/**
* | output |
* | --- |
* | "Name Usersettings Modify" |
*
* @param {Enum_Permission_Name_Usersettings_ModifyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const enum_permission_name_usersettings_modify = /** @type {((inputs?: Enum_Permission_Name_Usersettings_ModifyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Permission_Name_Usersettings_ModifyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_permission_name_usersettings_modify(inputs)
	return de_enum_permission_name_usersettings_modify(inputs)
});